<script setup>
import {
  WButton,
  WCheckbox,
  WTable,
  WTableBody,
  WTableBodyCell,
  WTableHeader,
  WTableHeaderCell,
  WTableRow,
  WTextfield,
  WTitle
} from '@alice-health/wonderland-vue'
import { onMounted, ref } from 'vue'

import { channelsInstance } from '@/api/instances'

const id = ref(undefined)
const items = ref(undefined)
const fields = ref([])
const selectedFields = ref([
  'kind',
  'category',
  'subCategory',
  'action',
  'staffIds',
  'createdAt'
])

const getFields = async () => {
  fields.value = await channelsInstance.get(
    'debug/channel/history/model_fields'
  )
}

const getHistory = async () => {
  items.value = await channelsInstance.get(`debug/channel/history/${id.value}`)
}

const toggleField = (event, field) => {
  if (event.detail) {
    selectedFields.value.push(field)
  } else {
    selectedFields.value.splice(selectedFields.value.indexOf(field), 1)
  }
}

const toggleAllField = event => {
  if (event.detail) {
    selectedFields.value = fields.value
  } else {
    selectedFields.value = []
  }
}

onMounted(() => {
  getFields()
})
</script>

<template>
  <form :id="id" class="debug_history_form" @submit.prevent>
    <WTitle size="small" class="debug__input"> Histórico de Canal </WTitle>

    <WTextfield
      v-model="id"
      placeholder="Id do canal"
      :required="true"
      label="Channel Id"
      class="debug__input"
    />
    <WTitle size="small" class="debug__input"> Campos: </WTitle>
    <div class="fields_grid">
      <WCheckbox
        :checked="selectedFields == fields"
        label="Todos"
        @w-change="toggleAllField($event)"
      />
      <div v-for="field in fields" :key="field">
        <WCheckbox
          :checked="selectedFields.includes(field)"
          :label="field"
          @w-change="toggleField($event, field)"
        />
      </div>
    </div>
    <WButton class="debug__cta" block :disabled="!id" @click="getHistory">
      Buscar Histórico
    </WButton>

    <div v-if="items">
      <WTitle size="small" class="debug__input"> Histórico: </WTitle>
      <WTable>
        <WTableHeader slot="header">
          <WTableHeaderCell v-for="field in selectedFields" :key="field">{{
            field
          }}</WTableHeaderCell>
        </WTableHeader>
        <WTableBody slot="body">
          <WTableRow v-for="historyItem in items" :key="historyItem.id">
            <WTableBodyCell v-for="field in selectedFields" :key="field">{{
              historyItem[field]
            }}</WTableBodyCell>
          </WTableRow>
        </WTableBody>
      </WTable>
    </div>
  </form>
</template>

<style lang="scss">
.fields_grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 10px;
  padding-bottom: 20px;
}

.debug_history_form {
  display: flex;
  flex-direction: column;
  gap: var(--gl-spacing-01);
  width: 100%;
}
</style>
